/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const BASE_INFO_FIELD_KEYS = {
  name: 'base.name',
  description: 'base.description',
  workspace: 'base.workspace',
  namespace: 'base.namespace',
  datacenter: 'base.datacenter',
} as const;

export const BASE_INFO_FIELD_KEY_LIST = [
  BASE_INFO_FIELD_KEYS.name,
  BASE_INFO_FIELD_KEYS.description,
  BASE_INFO_FIELD_KEYS.workspace,
  BASE_INFO_FIELD_KEYS.namespace,
  BASE_INFO_FIELD_KEYS.datacenter,
] as const;

export const BASE_INFO_OPTION_META_KEYS = {
  workspace: 'workspace',
};
